<template>
 
    <canvas ref="canvas" class="pix_canvas"></canvas>
  
</template>

<script>
import {array2canvas} from '~js/img_array_canvas.js';
import {resize,ndim} from '~pjs/xfl_math.esm.js';
let x_arr = [[1,0,1], [0,1,0], [1,0,1]];

export default ({
    name:'ArrayCanvas',
    props:{
        canvas_style:String,
        size:Array,
        data:Array,
        title:String,
        editable:Boolean,
        

    },
    data(){
        return {
            //editable:true,
            color_info:'binary',//rgb 三彩 binary二进制 gray灰度图 
            show_rng:[0,1],
            last_change_grid:[],
            //data:[[1,0,0,0,1], [0,1,0,1,0], [0,0,1,0,0], [0,1,0,1,0], [1,0,0,0,1]],
        }
        
    },
    computed:{

    
        canvas_array(){
            let dim = ndim(this.data);
            if(dim==1){//如果是一维, 那么size信息需要
                if(!this.size){
                    console.warn("一维数据需要size信息来生成二维"); 
                    return x_arr;
                };
                return resize(this.data,this.size);
            }else{
                return this.data;
            }
        }
    },
    mounted() {
        let scope = this;
        function POC(evt,canvas){
            let {clientX:x,clientY:y} = evt;
            var bbox = canvas.getBoundingClientRect();
            return {
                x:Math.floor((x - bbox.left)/(bbox.width/canvas.width)),
                y:Math.floor((y - bbox.top)/(bbox.height/canvas.height))
            }
        };

        array2canvas(this.canvas_array,this.$refs.canvas,this.show_rng);
        let canvas = this.$refs.canvas;
        canvas.addEventListener('mousedown',canvas_mouse_down,false);
        canvas.addEventListener('mouseup',canvas_mouse_up,false);
        canvas.addEventListener('mousemove',canvas_mouse_move,false);
        canvas.addEventListener('contextmenu',disable_context_menu,false);
        // canvas.addEventListener('mousewheel',canvas_mouse_wheel,false);
        function disable_context_menu(e){
            if(e.button == 2) {
						e.preventDefault();
            }
        }
        let is_down = false;
        let down_pos ={x:0,y:0};
        function canvas_mouse_down(e){
            console.log('mouse down event');
            is_down = true;
            let pos = POC(e,canvas) ;
            let {x,y} = pos;
            down_pos = {x:pos.x,y:pos.y};
            console.log(pos);
            let new_value;
           
            if(scope.editable){
                switch(scope.color_info){
                    case 'binary':{
                        let old_value = scope.data[y][x];
                        new_value = old_value!=0?0:1;
                        if(e.button==2){
                            new_value = 0;//右键0
                            e.cancelBubble = true
                            e.returnValue = false;

                        }

                        scope.$set(scope.data[y],x,new_value);
                    };
                    case 'rgb':
                    case 'gray':
                        console.log('Not support now');
                }
                
            }
            scope.$emit('click_change',pos,new_value);
        };
        function canvas_mouse_up(e){
            console.log('mouse up');
            is_down = false;
        }

        function canvas_mouse_move(e){
            if(!is_down)return;
            console.log('mouse down move event');
            let pos = POC(e,canvas) ;
            let {x,y} = pos;
            if(pos.x==down_pos.x && pos.y==down_pos.y){console.log('No move return');return}
            let new_value;
           
            if(scope.editable){
                switch(scope.color_info){
                    case 'binary':{
                        //let old_value = scope.data[y][x];
                        new_value = e.buttons==1?1:0;
  
                        scope.$set(scope.data[y],x,new_value);
                    };
                    case 'rgb':
                    case 'gray':
                        console.log('Not support now');
                }
                
            }
            scope.$emit('click_change',pos,new_value);
        };


   



    },
   
    watch:{
        data:{
            deep:true,
            handler(){
                console.log('vue canvas data changed');
                array2canvas(this.canvas_array,this.$refs.canvas,this.show_rng);
            }
        }
    }
})
</script>

<style lang="stylus" scoped>
canvas
    min-width:10px;
    min-height:10px;
    image-rendering: pixelated;
    image-rendering: -moz-crisp-edges;
    width:100%;
    height:100%

</style>
